<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        v-if="isTrans == 'true'"
        class="d-flex w-100 justify-content-end"
      >
        <v-btn color="primary" @click="onClickCancel">
          {{ $t("cancel_beneficary") }}
        </v-btn>
      </v-col>

      <v-col cols="12" md="6">
        <label
          >{{ $t("firstName")
          }}<span style="color: #f00">*</span></label
        >
        <v-text-field
          v-model="beneficiaryReqBody.first_name"
          dense
          :placeholder="$t('firstname_beneficary')"
          required
          :error-messages="firstNameErrors"
          @input="$v.beneficiaryReqBody.first_name.$touch()"
          @blur="$v.beneficiaryReqBody.first_name.$touch()"
          outlined
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <label>{{ $t("lastname_beneficary") }}</label>
        <v-text-field
          v-model="beneficiaryReqBody.last_name"
          :placeholder="$t('lastname_beneficary')"
          dense
          required
          :error-messages="lastNameErrors"
          @input="$v.beneficiaryReqBody.last_name.$touch()"
          @blur="$v.beneficiaryReqBody.last_name.$touch()"
          outlined
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <label>{{ $t("date_of_birth_benificary") }}</label>
        <!-- <v-text-field
          type="date"
          v-model="beneficiaryReqBody.dob"
          :error-messages="DOBerrors"
          @input="$v.beneficiaryReqBody.dob.$touch()"
          placeholder="Date Of Birth"
          dense
          outlined
          required
        ></v-text-field> -->
        <v-menu
          ref="dobmenu"
          v-model="dobmenu"
          :close-on-content-click="false"
          lazy
          transition="scale-transition"
          :offset-x="true"
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="beneficiaryReqBody.dob"
              persistent-hint
              clearable
              v-on="on"
              type="date"
              dense
              @change="ValidateAge"
              :min="minDate"
              :max="maxDate"
              outlined
            >
              <!-- <v-icon
                slot="append"
                medium
                v-on="on"
                v-bind="attrs"
                :disabled="!mutableIsEditVal"
                class="custome_icon"
              >
                mdi-calendar
              </v-icon> -->
            </v-text-field>
          </template>
          <!-- <v-date-picker
            v-model="spUserIndividual.date_of_birth"
            width="300"
            id="cus_ind_dob"
            year-icon="mdi-calendar"
            prev-icon="mdi-skip-previous"
            next-icon="mdi-skip-next"
            :first-day-of-week="1"
            :max="maxDate"
            :min="minDate"
            color="primary lighten-1"
            @input="dobmenu = false"
            :disabled="!mutableIsEditVal"
          ></v-date-picker> -->
        </v-menu>
      </v-col>

      <v-col cols="12" md="6">
        <label>{{ $t("designation_beneficary") }}</label>
        <v-text-field
          v-model="beneficiaryReqBody.designation"
          :placeholder="$t('designation_beneficary')"
          dense
          outlined
          required
        ></v-text-field>
      </v-col>
      <!-- 
      <v-col cols="12" md="6">
        <label class="mt-1"
          >{{ $t("idType")
          }}<span style="color: #f00">*</span></label
        >
        <v-autocomplete 
          v-model="beneficiaryReqBody.id_type"
          :placeholder="$t('id_type_placeholder')"
          :items="[
            'Passport',
            'IC',
            'Driving Licence',
            'Company Registration',
            'MyPR',
            'Work Permit',
            'Other',
          ]"
          outlined
          required
          :error-messages="idTypeErrors"
          @input="$v.beneficiaryReqBody.id_type.$touch()"
          @change="$v.beneficiaryReqBody.id_type.$touch()"
          dense
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="6">
        <label
          >{{ $t("idNumber")
          }}<span style="color: #f00">*</span></label
        >
        <v-text-field
          :placeholder="$t('id_number_placeholder_beneficary')"
          dense
          :error-messages="idNumberErrors"
          @input="$v.beneficiaryReqBody.id_number.$touch()"
          @change="$v.beneficiaryReqBody.id_number.$touch()"
          v-model="beneficiaryReqBody.id_number"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" v-if="beneficiaryReqBody.id_type == 'Passport'">
        <label
          >{{ $t("isuueDate")
          }}<span style="color: #f00">*</span></label
        >
        <v-text-field
          v-model="beneficiaryReqBody.issue_date"
          :placeholder="$t('isuueDate')"
          :error-messages="issueDateErrors"
          @input="$v.beneficiaryReqBody.issue_date.$touch()"
          @blur="$v.beneficiaryReqBody.issue_date.$touch()"
          dense
          required
          outlined
          type="date"
        />
      </v-col>

      <v-col cols="12" md="6" v-if="beneficiaryReqBody.id_type == 'Passport'">
        <label
          >{{ $t("location")
          }}<span style="color: #f00">*</span></label
        >
        <v-autocomplete 
          v-model="beneficiaryReqBody.issue_location"
          :items="country_options"
          :error-messages="locationErrors"
          @input="$v.beneficiaryReqBody.issue_location.$touch()"
          @blur="$v.beneficiaryReqBody.issue_location.$touch()"
          :placeholder="$t('location')"
          dense
          outlined
          required
        />
      </v-col>

      <v-col cols="12" md="6" v-if="beneficiaryReqBody.id_type == 'Passport'">
        <label
          >{{ $t("expiryDate")
          }}<span style="color: #f00">*</span></label
        >
        <v-text-field
          v-model="beneficiaryReqBody.expiry_date"
          :placeholder="$t('expiryDate')"
          :error-messages="expireDateErrors"
          @input="$v.beneficiaryReqBody.expiry_date.$touch()"
          @blur="$v.beneficiaryReqBody.expiry_date.$touch()"
          dense
          outlined
          required
          type="date"
        />
      </v-col> -->
      <v-col cols="12" md="6">
        <label :description="$t('optional')">
          {{ $t("phoneNumber") }}<span style="color: #f00">*</span>
        </label>
        <vue-phone-number-input
          :default-country-code="phone_code"
          v-model="beneficiaryReqBody.phone_number"
          :error-messages="phoneErrors"
          @input="$v.beneficiaryReqBody.phone_number.$touch()"
          @blur="$v.beneficiaryReqBody.phone_number.$touch()"
          @update="onChangeNumber"
          :error="!isValidNumber"
          class=""
          required
        />
        <span style="color: #ff5252; font-size: 12px">{{
          phoneErrors[0]
        }}</span>
      </v-col>
      <v-col cols="12" md="6">
        <label :description="$t('optional')">
          {{ $t("emailAddress") }}
        </label>
        <v-text-field
          :placeholder="$t('email_beneficary')"
          dense
          type="email"
          required
          v-model="beneficiaryReqBody.email_id"
          :error-messages="emailErrors"
          @input="$v.beneficiaryReqBody.email_id.$touch()"
          @blur="$v.beneficiaryReqBody.email_id.$touch()"
          outlined
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="12">
        <v-btn
          class="float-left mt-5 px-5 btn-primary-outlined text-capitalize"
          outlined
          @click="onClickBack"
          ><v-icon dark left>mdi-arrow-left</v-icon>
          {{ $t("backLabel") }}</v-btn
        >
        <v-btn
          class="float-right mt-5 px-5 btn-primary-outlined text-capitalize"
          outlined
          @click="onClickNext"
          >{{ $t("next") }} <v-icon dark right>mdi-arrow-right</v-icon></v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import {
  required,
  email,
  // requiredIf,
  numeric,
  alphaNum,
} from "vuelidate/lib/validators";
import { findDatePrevious } from "../../../utils/helper";
import { alpha } from "../../../utils/validate";
export default {
  name: "RepresentativeInfo",
  data: () => ({
    dobmenu: false,
    maxDate: "",
    minDate: "",
    isDobError: false,
    isValidNumber: false,
    country_options: [],
    phone_code: "",
  }),
  props: {
    beneficiaryReqBody: {
      type: Object,
      required: true,
    },
    bene_country_name: {
      type: String,
      default: "",
    },
    BusrecieverData: {
      type: Object,
      required: true,
    },
    isTrans: {
      type: String,
      default: "",
    },
  },
  components: {
    VuePhoneNumberInput,
  },
  watch: {
    bene_country_name: {
      handler(country) {
        this.phone_code = country;
      },
    },
    BusrecieverData: {
      handler(data) {
        console.log("data", data);
        this.beneficiaryReqBody.first_name = data.first_name;
        this.beneficiaryReqBody.last_name = data.last_name;
        this.beneficiaryReqBody.dob = data.dob ? data.dob : null;
        this.beneficiaryReqBody.designation = data.designation;
        this.beneficiaryReqBody.postal_code = data.postal_code;
        this.beneficiaryReqBody.email_id = data.email_id;
        this.beneficiaryReqBody.phone_number = data.phone_number;
        if (data.phone_number_cty_code) {
          this.phone_code = data.phone_number_cty_code;
        }
      },
    },
    "beneficiaryReqBody.phone_number"(val) {
      console.log(val);
    },
  },

  mounted() {
    this.phone_code =
      this.BusrecieverData?.phone_number_cty_code || this.bene_country_name;
    if (!this.$route.query.Remittee_ID) {
      this.beneficiaryReqBody.phone_number_cty_code = this.bene_country_name;
    }
    this.maxDate = findDatePrevious(new Date(), 18);
    this.minDate = findDatePrevious(new Date(), 70);

    // this.getCountryList();
  },
  computed: {
    ...mapGetters("Authentication", ["country_list"]),
    firstNameErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.first_name.$dirty) return errors;
      !this.$v.beneficiaryReqBody.first_name.required &&
        errors.push(this.$t("first_name"));
      !this.$v.beneficiaryReqBody.first_name.alpha &&
        errors.push(this.$t("invalid_first_name"));
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.last_name.$dirty) return errors;
      // !this.$v.beneficiaryReqBody.last_name.required &&
      //   errors.push(this.$t("last_name"));
      !this.$v.beneficiaryReqBody.last_name.alpha &&
        errors.push(this.$t("invalid_last_name"));
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.email_id.$dirty) return errors;
      // !this.$v.beneficiaryReqBody.email_id.required &&
      //   errors.push(this.$t("email_id"));
      !this.$v.beneficiaryReqBody.email_id.email &&
        errors.push(this.$t("invalid_email"));
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.phone_number.$dirty) return errors;
      !this.$v.beneficiaryReqBody.phone_number.required &&
        errors.push(this.$t("phone_num"));
      this.$v.beneficiaryReqBody.phone_number.required &&
        !this.$v.beneficiaryReqBody.phone_number.validPhoneNumber &&
        errors.push(this.$t("invalid_contact_number"));
      return errors;
    },
    // idTypeErrors() {
    //   const errors = [];
    //   if (!this.$v.beneficiaryReqBody.id_type.$dirty) return errors;
    //   !this.$v.beneficiaryReqBody.id_type.required &&
    //     errors.push(this.$t("select_id_type"));
    //   return errors;
    // },
    // issueDateErrors() {
    //   const errors = [];
    //   if (!this.$v.beneficiaryReqBody.issue_date.$dirty) return errors;
    //   !this.$v.beneficiaryReqBody.issue_date.required &&
    //     errors.push(this.$t("select_issue_date"));
    //   return errors;
    // },
    // idNumberErrors() {
    //   const errors = [];
    //   if (!this.$v.beneficiaryReqBody.id_number.$dirty) return errors;
    //   !this.$v.beneficiaryReqBody.id_number.required &&
    //     errors.push(this.$t("enter_id_number"));

    //     switch(this.beneficiaryReqBody.id_type) {
    //       case 'Passport':
    //       case 'Drivers License':
    //         if(!this.$v.beneficiaryReqBody.id_number.alphaNum) {
    //           errors.push(this.$t("invalid_id_num"));
    //         }
    //         break;
    //       case 'Identification Card':
    //         if(this.beneficiaryReqBody.id_number.length < 12 || this.beneficiaryReqBody.id_number.length > 12)
    //           errors.push(this.$t("ID number must be 12 digits only"));
    //         if(!this.$v.beneficiaryReqBody.id_number.numeric) errors.push(this.$t("invalid_id_num"));
    //         break;
    //       case 'Company Registration':
    //       case 'MyPR':
    //       case 'Other':
    //       case 'Work Permit':
    //         if(!this.$v.beneficiaryReqBody.id_number.numeric) errors.push(this.$t("invalid_id_num"));
    //         break;
    //       default: break;
    //     }
    //   return errors;
    // },
    // locationErrors() {
    //   const errors = [];
    //   if (!this.$v.beneficiaryReqBody.issue_location.$dirty) return errors;
    //   !this.$v.beneficiaryReqBody.issue_location.required &&
    //     errors.push(this.$t("select_location"));
    //   return errors;
    // },
    // expireDateErrors() {
    //   const errors = [];
    //   if (!this.$v.beneficiaryReqBody.expiry_date.$dirty) return errors;
    //   !this.$v.beneficiaryReqBody.expiry_date.required &&
    //     errors.push(this.$t("select_expire_date"));
    //   return errors;
    // },
    designationErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.designation.$dirty) return errors;
      // !this.$v.beneficiaryReqBody.designation.required &&
      //   errors.push(this.$t("designation"));
      !this.$v.beneficiaryReqBody.designation.alpha &&
        errors.push(this.$t("invalid_designation"));
      return errors;
    },
    DOBerrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.dob.$dirty) return errors;
      // !this.$v.beneficiaryReqBody.dob.required &&
      //   errors.push(this.$t("select_dob"));
      if (this.isDobError) {
        errors.push(this.$t("invalid_dob"));
      }
      return errors;
    },
    idTypeRules() {
      let obj = {};
      switch (this.beneficiaryReqBody.id_type) {
        case "Passport":
        case "Drivers License":
          obj = {
            required,
            alphaNum,
          };
          break;
        default:
          obj = {
            required,
            alphaNum,
            numeric,
          };
          break;
      }
      return obj;
    },
  },
  validations() {
    return {
      beneficiaryReqBody: {
        first_name: {
          required,
          alpha,
        },
        last_name: {
          alpha,
        },
        // dob: {
        //   required,
        // },
        phone_number: {
          required,
          validPhoneNumber: () => this.isValidNumber,
        },
        designation: {
          // required,
          alpha,
        },
        email_id: {
          // required,
          email,
        },
        // id_type: {
        //   required,
        // },
        // id_number: this.idTypeRules,
        // issue_date: {
        //   required: requiredIf(function () {
        //     if (this.beneficiaryReqBody.id_type == "Passport") return true;
        //     else return false;
        //   }),
        // },
        // expiry_date: {
        //   required: requiredIf(function () {
        //     if (this.beneficiaryReqBody.id_type == "Passport") return true;
        //     else return false;
        //   }),
        // },
        // issue_location: {
        //   required: requiredIf(function () {
        //     if (this.beneficiaryReqBody.id_type == "Passport") return true;
        //     else return false;
        //   }),
        // },
      },
    };
  },
  methods: {
    ValidateAge(value) {
      if (!value) this.isDobError = false;
      else this.isDobError = !(value <= this.maxDate && value >= this.minDate);
    },
    onClickCancel() {
      this.$router.push("/transaction/3");
    },
    onChangeNumber(e) {
      console.log("mobile", e);
      this.isValidNumber = e.isValid;
      this.beneficiaryReqBody.phone_number_cty_code = e.countryCode;
    },
    onClickBack() {
      this.$emit("onClickBack");
    },
    onClickNext() {
      console.log(
        `beneficiaryReqBody: ${JSON.stringify(this.beneficiaryReqBody)}`
      );
      console.log("this.$v", this.$v);
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.beneficiaryReqBody.phone_number =
        this.beneficiaryReqBody.phone_number.replace(/ /g, "");
      // Object.assign(this.beneficiaryData, { basicDetails: this.beneficiary })
      this.$emit("onClickNext", this.beneficiaryReqBody);
    },
    // async getCountryList() {
    //   await this.$store.dispatch("Authentication/getCountryService");
    //   console.log("this.country_list",this.country_list);
    //   this.country_options = await this.country_list.country.data.map(
    //     (i) => i.name
    //   );
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.invalid-feedback-name {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
</style>
